import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSession } from "@/lib/auth-session";

export const Route = createFileRoute("/admin")({
	beforeLoad: async () => {
		const session = await getSession();
		if (!session?.user) {
			throw redirect({ to: "/login" });
		}
		const role = (session.user as { role?: string }).role;
		if (role !== "admin" && role !== "operator") {
			throw redirect({ to: "/" });
		}
		return { session };
	},
	component: AdminLayout,
});

function AdminLayout() {
	return <Outlet />;
}
